import { useCallback, useState } from 'react'
import ExternalLinkDialog from '../components/ExternalLinkDialog'
import { openExternalArticle } from '../lib/externalLink'

/**
 * 统一的外链打开逻辑（列表卡片、精选推荐、详情页共用一套口径）。
 *
 * 用法：
 *   const { openLink, dialog } = useExternalArticle()
 *   <button onClick={() => openLink(item.link_url!)}>…</button>
 *   {dialog}   // 渲染在组件任意位置即可
 *
 * 说明：`dialog` 只在「需要用户复制链接」时才有内容（普通浏览器环境下
 * 外链会被直接打开，不会弹窗），所以各处都渲染它不会造成多余的 DOM。
 */
export function useExternalArticle() {
  const [copyUrl, setCopyUrl] = useState<string | null>(null)

  const openLink = useCallback((url: string) => {
    const action = openExternalArticle(url)
    if (action.kind === 'copy') setCopyUrl(action.url)
  }, [])

  const closeDialog = useCallback(() => setCopyUrl(null), [])

  return {
    openLink,
    dialog: copyUrl ? <ExternalLinkDialog url={copyUrl} onClose={closeDialog} /> : null,
  }
}
